import { statusRecipe } from '../constants/recipe-status.constant';

export const recipeStatus = (status) => {
	console.log(status)
	return statusRecipe[status] || statusRecipe.RV;
};
